import React, { useState, useEffect } from "react";
import { TiSocialFacebook } from "react-icons/ti";
import { TiSocialTwitter } from "react-icons/ti";
import { TiSocialLinkedin } from "react-icons/ti";
import "./Header.css";
import { images } from "../../config/images";

const Header = ({headerAPIData}) => {
  const [containerClass, setContainerClass] = useState("container-fluid");

  const handleResize = () => {
    if (window.innerWidth >= 1200) {
      setContainerClass("container");
    } else {
      setContainerClass("container-fluid");
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  return (
    <>
      <div className="header common-sec">
        <div className="header-wrap">
          <div>
            <div className="header-left">
              {/* Facebook Link */}
              <div>
                <a
                  href={
                    headerAPIData?.header?.facebook_link || "https://www.facebook.com"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TiSocialFacebook className="social-icon" />
                </a>
              </div>
              {/* Twitter Link */}
              <div>
                <a
                  href={
                    headerAPIData?.header?.twitter_link || "https://www.twitter.com"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TiSocialTwitter className="social-icon" />
                </a>
              </div>
              {/* LinkedIn Link */}
              <div>
                <a
                  href={
                    headerAPIData?.header?.linkedin_link || "https://www.linkedin.com"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TiSocialLinkedin className="social-icon" />
                </a>
              </div>
            </div>
          </div>

          <div className="header-right">
            {/* Phone Number */}
            <div className="info-details">
              <div>
                <img
                  src={images.contact}
                  className="info-icon"
                  alt="contact icon"
                />
              </div>
              <div>
                <h6>
                  <a href={`tel:${headerAPIData?.header?.top_header_phone || "+91 8758881633"}`} style={{ textDecoration: "none", color: "unset" }} >
                    {headerAPIData?.header?.top_header_phone || "+91 8758881633"}
                  </a>
                  {/* {headerAPIData?.top_header_phone || "+91 8758881633"} */}
                </h6>
              </div>
            </div>
            {/* Email */}
            <div className="info-details">
              <div>
                <img
                  src={images.email}
                  className="info-icon"
                  alt="email icon"
                />
              </div>
              <div>
                <h6>
                  <a href={`mailto:${headerAPIData?.header?.top_header_email ||
                    "anaxlifescience@gmail.com"}`} style={{ textDecoration: "none", color: "unset" }}>
                    {headerAPIData?.header?.top_header_email ||
                      "anaxlifescience@gmail.com"}
                  </a>
                  {/* {headerAPIData?.top_header_email ||
                    "anaxlifescience@gmail.com"} */}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
